import axios from 'axios';
import { apiHost, defaultTimeout } from './constants';

const httpClient = axios.create({
    baseURL: apiHost,
    timeout: defaultTimeout,
});

export default httpClient;
